module.exports = __webpack_public_path__ + "img/EquipFacilities.753ce011.svg";